// @flow
import React, { Component, Fragment, type Node } from 'react';
import {
  ModelListTable,
  ModelListDiv
} from '../../../../components/ModelListStyles';
import MerchantTransactionRow from './MerchantTransactionRow';
import MerchantTransactionDetailedRow from './MerchantTransactionDetailedRow';
import { SmDesktop, Tablet, Mobile } from '../../../../components/Responsive';
import EmptyTable from '../../../../components/EmptyTable';
import TableLoader from '../../../../components/TableLoader';
import { type Transaction } from '..';
import { type Currencies } from '../../../../utilities/types';
import Paginator from '../../../../components/Paginator';
import MerchantTransactionHead from './MerchantTransactionHead';
import CustomPerPageFilter from '../../../../modules/CrudTable/components/CustomPerPageFilter';

type Props = {
  transactions: Transaction[],
  expandedRow: number,
  expandRow: (id: number) => void,
  currencies: Currencies,
  transactionsFailedLoad: boolean,
  transactionsLoading: boolean,
  currentPage: number,
  changePage: (value: number) => void,
  previouslyVisited: number[],
  paginatorTotal: number,
  orderBy: ?string,
  orderDirection: ?string,
  changeSortOrder: (orderBy: string) => void,
  showTooltip: (tooltip: string) => void,
  activeTooltip: ?string,
  perPage: string,
  setPerPage: (perPage: number) => void,
  perPageOptions: Array<number>
};

export default class MerchantTransactionTable extends Component<Props> {
  renderDetailedRow = (transaction: Transaction, colSpan: number) => (
    <MerchantTransactionDetailedRow
      transaction={transaction}
      colSpan={colSpan}
      currencies={this.props.currencies}
    />
  );

  renderBody = () => {
    if (this.props.transactionsFailedLoad) {
      return <EmptyTable error columns={8} model="Transactions" />;
    } else if (this.props.transactionsLoading) {
      return <TableLoader columns={8} />;
    } else if (this.props.transactions.length === 0) {
      return (
        <EmptyTable
          text="No merchant transactions to show"
          columns={8}
          model="Transactions"
          img="receipt"
        />
      );
    } else {
      return (this.props.transactions.map(transaction => (
        <Fragment key={transaction.id}>
          <MerchantTransactionRow
            expandRow={this.props.expandRow}
            key={transaction.id}
            transaction={transaction}
            currencies={this.props.currencies}
            expandedRow={this.props.expandedRow}
          />
          {this.props.expandedRow === transaction.id && (
            <>
              <SmDesktop>{this.renderDetailedRow(transaction, 4)}</SmDesktop>
              <Tablet>{this.renderDetailedRow(transaction, 4)}</Tablet>
              <Mobile>{this.renderDetailedRow(transaction, 3)}</Mobile>
            </>
          )}
        </Fragment>
      )): Array<Node>);
    }
  };

  render() {
    return (
      <ModelListDiv withPagination>
        <ModelListTable smallMarginBottom>
          <MerchantTransactionHead
            orderBy={this.props.orderBy || ''}
            orderDirection={this.props.orderDirection || ''}
            changeSortOrder={this.props.changeSortOrder}
            showTooltip={this.props.showTooltip}
            activeTooltip={this.props.activeTooltip || ''}
          />
          <tbody>{this.renderBody()}</tbody>
        </ModelListTable>
        <CustomPerPageFilter
          currentPerPage={this.props.perPage || ''}
          // $FlowFixMe
          setPerPage={this.props.setPerPage}
          perPageOptions={this.props.perPageOptions || []}
          alignWithTable
        ></CustomPerPageFilter>
        {this.props.transactions.length === 0 || (
          <Paginator
            paginatorTotal={this.props.paginatorTotal}
            currentPage={this.props.currentPage}
            changePage={this.props.changePage}
            previouslyVisited={this.props.previouslyVisited}
          />
        )}
      </ModelListDiv>
    );
  }
}
